import { useQuery } from "@tanstack/react-query";
import { QueryKey } from "./constants";
import api, { baseUrl } from "../services/api";

export const useAreas = (id) => {
  const queryKey = [QueryKey.Areas];

  const queryFn = async () => {
    const URL = `${baseUrl}/cities/${id}/areas`;

    const { data } = await api.get(URL);

    return data;
  };

  return useQuery({
    queryKey: queryKey,
    queryFn: queryFn,
    enabled: !!id,
  });
};
